import { render, staticRenderFns } from "./ProgressAlbum.vue?vue&type=template&id=06b11530&scoped=true"
import script from "@/views/Users/Student/Progress/ProgressAlbum.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Progress/ProgressAlbum.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/Progress/progress-album.scss?vue&type=style&index=0&id=06b11530&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b11530",
  null
  
)

export default component.exports